import { GetLocationUsers } from 'domain/usecases/get-location-users';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetLocationUsers extends BaseHttpService<GetLocationUsers.Model> implements GetLocationUsers {
  async getAll(params: GetLocationUsers.Params): Promise<GetLocationUsers.Model> {
    return await this.request('get', {}, params);
  }
}
